// extracted by mini-css-extract-plugin
module.exports = {"teams":"teams_teams__cHOuc","teams__component":"teams_teams__component__2ny1k","teams__content":"teams_teams__content__Z4KEW","teams__team":"teams_teams__team__3Bk_Q"};